import { render, staticRenderFns } from "./HtmlColumn.vue?vue&type=template&id=7bd5dd3c&scoped=true"
import script from "./HtmlColumn.vue?vue&type=script&lang=js"
export * from "./HtmlColumn.vue?vue&type=script&lang=js"
import style0 from "./HtmlColumn.vue?vue&type=style&index=0&id=7bd5dd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd5dd3c",
  null
  
)

export default component.exports